import { Component, Inject, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../modal-findings/modal-findings.component';
import { UserService } from '@core/user/user.service';
@Component({
  selector: 'bid-modal-icr-role',
  templateUrl: './modal-icr-role.component.html',
  styleUrls: ['./modal-icr-role.component.scss'],
})
export class ModalICRRoleComponent implements OnInit {
  isFinishIcr;
  followUp: SelectItem[];
  isSave: boolean;
  texts: any = { PTL: [], PRM: [], OEG: [], OEA: [] };
  results: any = { PTL: [], PRM: [], OEG: [], OEA: [] };
  info: any = { PTL: [], PRM: [], OEG: [], OEA: [] };
  request: string;
  _analysis: any = {
    id: '',
    mail_usuarios_prm: '',
    mail_usuarios_ptl: '',
    mail_usuarios_oeg: '',
    mail_usuarios_oea: '',
    mail_usuarios_egf: '',
  };
  constructor(
    public dialogRef: MatDialogRef<ModalICRRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData | any,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.isSave = false;
    this.request = this.data.toString();
    console.log('data', this.data);

    this.getUsersData();
  }

  getUsersData() {
    this.userService.getUserConvergencia(this.request).subscribe((data: any) => {
      this.results.PTL = data.filter((item) => item.role === 'PTL');
      this.results.PRM = data.filter((item) => item.role === 'PRM');
      this.results.OEG = data.filter((item) => item.role === 'OEG');
      this.results.OEA = data.filter((item) => item.role === 'OEA');

      console.log('this.results.PRM', this.results.PRM);
    });
  }
  onListSelectionChangePTL(ob) {
    this._analysis.mail_usuarios_ptl = ob.source._value.join();
  }
  onListSelectionChangePRM(ob) {
    this._analysis.mail_usuarios_prm = ob.source._value.join();
  }
  onListSelectionChangeOEG(ob) {
    this._analysis.mail_usuarios_oeg = ob.source._value.join();
  }
  onListSelectionChangeOEA(ob) {
    this._analysis.mail_usuarios_oea = ob.source._value.join();
  }
 
  onSaveClick(): void {
    this._analysis.id = this.request.split('|')[1].toString();
    this.userService.addUserAnalysis(this._analysis).subscribe((data: any) => {});
    this.dialogRef.close({});
  }

  save() {}
}
